import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-75a7898a")

_pushScopeId("data-v-75a7898a")
const _hoisted_1 = { class: "reportComfirm_carInfo" }
const _hoisted_2 = { class: "reportComfirm_carInfo_brand" }
const _hoisted_3 = { class: "reportComfirm_carInfo_brand_carMes" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "vin: ", -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "发动机号: ", -1)
const _hoisted_8 = { class: "reportComfirm_carInfo_cont" }
const _hoisted_9 = { class: "reportComfirm_carInfo_cont_item_label" }
const _hoisted_10 = { class: "reportComfirm_carInfo_cont_item_value" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_reportComfirmTitle = _resolveComponent("reportComfirmTitle")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_reportComfirmTitle, {
      titleTxt: "车辆信息",
      isShowRight: true,
      goPageType: "basic"
    }),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("h3", null, _toDisplayString(_ctx.state.brandName) + _toDisplayString(_ctx.state.modelName), 1),
        (_ctx.state.vin)
          ? (_openBlock(), _createBlock("p", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(_toDisplayString(_ctx.state.vin), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.state.engineNo)
          ? (_openBlock(), _createBlock("p", _hoisted_6, [
              _hoisted_7,
              _createTextVNode(_toDisplayString(_ctx.state.engineNo), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode("ul", _hoisted_8, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.basicItemInfos, (item) => {
        return (_openBlock(), _createBlock("li", {
          class: "reportComfirm_carInfo_cont_item",
          key: item.fieldCode
        }, [
          _createVNode("span", _hoisted_9, _toDisplayString(item.fieldName), 1),
          _createVNode("span", _hoisted_10, _toDisplayString(_ctx.format(item.fieldValue)), 1)
        ]))
      }), 128))
    ])
  ]))
})